module.exports = __webpack_public_path__ + "img/yoyolumi_intro_background.72da2233.png";